import React from 'react';
import { useParams } from 'react-router-dom';
import HeaderInner from "../components/HeaderInner";

const blogData = {
  'blog-1': {
    title: 'The Role Of Modern Car Wreckers',
    date: 'March 29, 2025',
    img: 'blog-1.jpg',
    content: `
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Numquam, consequuntur obcaecati mollitia reprehenderit fuga blanditiis excepturi.
      Totam earum veniam cum odio mollitia, aliquam magnam enim rerum exercitationem amet esse sit sint voluptates modi atque illum?
    `,
  },
  'blog-2': {
    title: 'Recycling Auto Parts',
    date: 'March 30, 2025',
    img: 'blog-2.jpg',
    content: `
      Recycling is a key part of modern car disposal services. We ensure parts are reused or safely discarded. Lorem ipsum dolor sit amet, consectetur.
    `,
  },
  'blog-3': {
    title: 'Eco-Friendly Car Disposal',
    date: 'March 31, 2025',
    img: 'blog-3.jpg',
    content: `
      Eco-friendly car disposal is essential for reducing environmental impact from automotive waste. This ensures safe recycling and sustainability.
    `,
  },
};

const BlogDetails = () => {
  const { id } = useParams();
  const blog = blogData[id];

  if (!blog) {
    return (
      <>
        <HeaderInner title="Blog" />
        <div className="container pt-6 pb-6 text-center">
          <h2>Blog not found</h2>
        </div>
      </>
    );
  }

  return (
    <>
      <HeaderInner title={blog.title} />
      <section className="blog-details pt-6 pb-6">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="blog-detail-img mb-4">
                <img
                  src={`/project/images/${blog.img}`}
                  alt={blog.title}
                  className="img-fluid w-100"
                />
              </div>
              <div className="blog-detail-content">
                <div className="blog-date mb-2">
                  <i className="fa-solid fa-calendar-days"></i>
                  <span className="ms-2">{blog.date}</span>
                </div>
                <h2>{blog.title}</h2>
                <p>{blog.content}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogDetails;
